import React from "react";
import PropTypes from "prop-types";
import GoogleMapsLoader from "google-maps";
GoogleMapsLoader.KEY = "AIzaSyBJ5gh-HqMPqJRm81QaXbE825CEH_ECZLo";
GoogleMapsLoader.LIBRARIES = ["geometry", "places"];
import PlacesAutocomplete, {
  geocodeByPlaceId,
  getLatLng,
} from "react-places-autocomplete";
import _ from "lodash";
import GeoLocation from "./GeoLocation";

/**
 * -PAC-
 * PAC (Places AutoComplete) component
 **/
class PAC extends React.Component {
  constructor(inputToggle) {
    super();
    this.inputToggle = ["false", "false"];
  }

  state = {};

  handleChange = (value, index) => {
    this.props.reportError();

    this.setState({
      value: value === undefined ? "" : value,
    });

    // Clear results
    if (value === "") {
      this.props.setLocation(this.props.index);
    }
  };

  handleSelect = (value, placeId) => {
    this.setState({
      value,
      placeId,
    });

    geocodeByPlaceId(placeId)
      .then((results) => getLatLng(results[0]))
      .then(({ lat, lng }) => {
        this.props.setLocation(this.props.index, lat, lng, value);
      })
      .catch((error) => this.handleError(error));
  };

  handleError = (error) => {
    switch (error) {
      case "ZERO_RESULTS":
        error = "No results were found";
        break;
      default:
        error = "Unknown error";
    }

    this.props.reportError(error, `locations_${this.props.index}`);
  };

  componentDidMount() {
    GoogleMapsLoader.load((google) => {
      this.setState(
        {
          google,
        },
        this.setOptions
      );

      this.props.autoCompleteReady(true);
    });
  }

  componentDidUpdate(prevProps, prevState) {
    // New name (eg from GeoLocation)
    const newLocation = !_.isEqual(this.props.location, prevProps.location);

    if (newLocation) {
      this.handleChange(this.props.location.name, this.props.index);
    }

    // Check if either input fields contain anything to then add clear button.
    let inputFields = document.querySelectorAll(".pac-location-input");

    let fieldNo = inputFields.length - 1;

    if (prevState.value !== this.state.value) {
      for (let i = 0; i < inputFields.length; i++) {
        if (inputFields[i].value !== "") {
          this.inputToggle[i] = "true";
        } else {
          this.inputToggle[i] = "false";
        }
      }

      if (
        this.inputToggle[0] === "true" ||
        this.inputToggle[fieldNo] === "true"
      ) {
        this.props.handleClearOptions("true");
      } else {
        this.props.handleClearOptions("false");
      }
    }
  }

  setOptions = () => {
    const { maps } = this.state.google;

    // Lookup bias by other (start = end, end = start) location, if set, or by bounds
    let location = {
      lat: this.props.location.lat,
      lng: this.props.location.lng,
    };
    location =
      location.lat && location.lng
        ? new maps.LatLng(location.lat, location.lng)
        : null;

    const lookup_bounds = location
      ? null
      : new maps.LatLngBounds(
          new maps.LatLng(51.293099, -3.012138), //sw - Brean
          new maps.LatLng(51.952969, -1.9672) // ne - Winchcombe
        );

    const options = {
      location: location,
      radius: location ? 25000 : null,
      bounds: lookup_bounds,
      componentRestrictions: { country: "uk" }, // restrict to uk
    };

    const classNames = {
      root: "pac-location-root",
      input: "pac-location-input",
      autocompleteContainer: "pac-location-container",
      autocompleteItem: "pac-location-item",
      autocompleteItemActive: "pac-location-item-active",
    };

    // Input options
    let value = this.props.location.name;
    value = value === undefined ? "" : value;

    this.setState({
      value,
      options,
      classNames,
      ready: true,
    });
  };

  renderPAC = () => {
    let placeholder;
    switch (this.props.index) {
      case 0:
        placeholder = "Starting Location";
        break;
      case this.props.locations.length - 1:
        placeholder = "Destination";
        break;
      default:
        placeholder = "Waypoint location";
    }

    let label;
    switch (this.props.index) {
      case 0:
        label = "From";
        break;
      case this.props.locations.length - 1:
        label = "To";
        break;
      default:
        label = "Waypoint";
    }

    const inputProps = {
      value: this.state.value,
      onChange: this.handleChange,
      type: "search",
      placeholder: placeholder,
      autoFocus: false,
      id: "pac-location-" + this.props.index,
      // required: true
    };

    const AutocompleteItem = ({ formattedSuggestion }) => (
      <div>
        <strong>{formattedSuggestion.mainText}</strong>{" "}
        <small>{formattedSuggestion.secondaryText}</small>
      </div>
    );

    return (
      <div>
        <label className="input-label" htmlFor={inputProps.id}>
          {label}
        </label>
        <div className="input-wrapper">
          <PlacesAutocomplete
            inputProps={inputProps}
            options={this.state.options}
            onSelect={this.handleSelect}
            onError={this.handleError}
            clearItemsOnError={true}
            classNames={this.state.classNames}
            highlightFirstSuggestion={true}
            autocompleteItem={AutocompleteItem}
          />

          {this.props.index === 0 && this.state.value === "" && (
            <GeoLocation
              index={this.props.index}
              setLocation={this.props.setLocation}
              reportError={this.props.reportError}
            />
          )}
        </div>
      </div>
    );
  };

  render() {
    return (
      <div className="pac-wrapper">{this.state.ready && this.renderPAC()}</div>
    );
  }
}

export default PAC;

PAC.propTypes = {
  location: PropTypes.object.isRequired,
  locations: PropTypes.array.isRequired,
  setLocation: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  reportError: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/PAC.js